<ng-container *ngIf="!!get && !!settings">
    <ng-container *ngIf="get.paged === '1'">
        <tt-stepper (ttPageIndexChange)="onPageChange($event)" style="max-width: 100rem; max-height: 100%">
            <ng-container *ngFor="let page of pages | keyvalue; trackBy: trackPagesBy">
                <tt-step
                    *ngIf="page.key.dep1_visible === '1' && page.key.dep2_visible === '1'"
                    [ttLabel]="page.key.checklistitem_method"
                    ttTranslateLabel="false"
                    [ttComplete]="page.value.complete"
                    [ttInvalid]="page.value.invalid"
                >
                    <ng-template>
                        <ng-container *ngFor="let item of page.value.items; trackChecklistItemBy">
                            <ng-container *ngTemplateOutlet="checklistItemElement; context: { $implicit: item }"></ng-container>
                        </ng-container>
                    </ng-template>
                </tt-step>
            </ng-container>

            <hr class="col-xs-12 sp-0 k-hr" style="margin-top: 0" />
            <ng-container *ngTemplateOutlet="checklistDataFunctions"></ng-container>
        </tt-stepper>
    </ng-container>

    <tt-card *ngIf="get.paged === '0'" class="col-xs-12 p-5" style="max-width: 100rem">
        <tt-editor *ngIf="!!settings.report_html" [ttModel]="settings.report_html" ttReadonly></tt-editor>
        <ng-container *ngFor="let item of get.checklistitems; trackChecklistItemBy">
            <ng-container *ngTemplateOutlet="checklistItemElement; context: { $implicit: item }"></ng-container>
        </ng-container>

        <ng-container *ngTemplateOutlet="checklistDataFunctions"></ng-container>
    </tt-card>
</ng-container>

<ng-template #checklistDataFunctions>
    <ng-container *ngIf="!!settings && !!get">
        <tt-button-goto
            ttText="pictures"
            [ttBadge]="get.nbr_of_pictures"
            [ttBeforeGoto]="saveChecklistData"
            ttGoto="pictures"
            [ttGotoParms]="{ argtype: 'checklistdata_keyno', argvalue: get.checklistdata_keyno }"
        ></tt-button-goto>
        <tt-button-goto
            ttText="checklistdata_print"
            ttIcon="fas fa-print"
            ttType="primary"
            ttTextAlign="center"
            ttIconAlign="right"
            ttGoto="selectreport"
            [ttGotoParms]="{ webpage_name: 'checklistdata', argtype: 'checklistdata_keyno', argvalue: get.checklistdata_keyno }"
        ></tt-button-goto>
        <tt-button-save *ngIf="settings.show_button_save === '1'" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        <tt-button-save *ngIf="settings.show_button_save_and_send === '1'" ttText="save_and_approve" (ttClick)="save({ approve: '1' })" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="settings.show_button_delete === '1'" ttText="delete" ttIcon="fad fa-trash" ttType="danger" (ttClick)="deleteChecklistData()" [ttLoading]="deleting"></tt-button>
    </ng-container>
</ng-template>

<ng-template #checklistItemElement let-item>
    <div [hidden]="item.dep1_visible === '0' || item.dep2_visible === '0'">
        <tt-page-heading *ngIf="item.elementtype === 'H1'">{{ item.checklistitem_method }}</tt-page-heading>
        <h3 *ngIf="item.elementtype === 'H2'" class="col-xs-12 sp-0 tt-card__heading" style="margin-top: 1.2rem">{{ item.checklistitem_method }}</h3>
        <hr *ngIf="item.elementtype === 'H2'" class="col-xs-12 sp-0 k-hr" style="margin-top: 0" />
        <tt-input
            *ngIf="item.elementtype === 'T'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
        ></tt-input>
        <tt-textarea
            *ngIf="item.elementtype === 'TL'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
        ></tt-textarea>
        <tt-select
            *ngIf="item.elementtype === 'CL'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
            [ttData]="item.checklistitemitem"
            ttDataId="checklistitemitem_keyno"
            ttDataName="checklistitemitem_name"
        ></tt-select>
        <tt-editor
            *ngIf="item.elementtype === 'HE'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
        ></tt-editor>
        <tt-date
            *ngIf="item.elementtype === 'DA'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
            [ttAllowEmpty]="item.r !== '1'"
        ></tt-date>
        <tt-datetime
            *ngIf="item.elementtype === 'DT'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
            [ttAllowEmptyDate]="item.r !== '1'"
            [ttAllowEmptyTime]="item.r !== '1'"
        ></tt-datetime>
        <tt-time
            *ngIf="item.elementtype === 'TI'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
            [ttAllowEmpty]="item.r !== '1'"
        ></tt-time>
        <tt-checkbox
            *ngIf="item.elementtype === 'CB' || item.elementtype === 'CS'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
        ></tt-checkbox>
        <tt-input-number
            *ngIf="item.elementtype.startsWith('N')"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
            [ttDecimals]="item.elementtype.substring(1) || 0"
        ></tt-input-number>
        <tt-input-signature
            *ngIf="item.elementtype === 'SI'"
            [ttRequired]="item.r === '1'"
            [ttLabel]="item.checklistitem_method"
            ttTranslateLabel="false"
            [ttSublabel]="item.expected_result"
            ttTranslateSublabel="false"
            [ttDataFormat]="settings?.signature_dataformat ?? ''"
            [(ttModel)]="item.itemvalue"
            (ttModelChange)="onChecklistItemChange(item)"
        ></tt-input-signature>
    </div>
</ng-template>
